import { Box, Input, Select } from '@nerdwallet/currency';
import Accordion from '@nerdwallet/react-accordion';
import { Fragment } from 'react';

import { marginAndPaddingUnitOptions } from '../../dynamic-grid-editing-configs';
import styles from './dynamic-accordion.module.scss';
import { useDynamicAccordion } from './use-dynamic-accordion';

export const DynamicAccordionSpacingsForm = ({
  fieldPath = '',
  spacings,
}: {
  fieldPath?: string;
  spacings?: any;
}) => {
  const {
    handleSpacingsChange,
    handleTabletSpacingsChange,
    handleMobileSpacingsChange,
  } = useDynamicAccordion();

  return (
    <Fragment>
      <Box padding={2}>
        <Input
          label="Padding Top"
          fullWidth
          value={spacings?.paddingTop}
          onChange={(e) => {
            handleSpacingsChange(
              fieldPath,
              'paddingTop',
              Number(e.target.value)
            );
          }}
        />
        <Input
          label="Padding Right"
          fullWidth
          value={spacings?.paddingRight}
          onChange={(e) => {
            handleSpacingsChange(
              fieldPath,
              'paddingRight',
              Number(e.target.value)
            );
          }}
        />
        <Input
          label="Padding Bottom"
          fullWidth
          value={spacings?.paddingBottom}
          onChange={(e) => {
            handleSpacingsChange(
              fieldPath,
              'paddingBottom',
              Number(e.target.value)
            );
          }}
        />
        <Input
          label="Padding Left"
          fullWidth
          value={spacings?.paddingLeft}
          onChange={(e) => {
            handleSpacingsChange(
              fieldPath,
              'paddingLeft',
              Number(e.target.value)
            );
          }}
        />
        <Select
          fullWidth
          value={spacings?.paddingUnit}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            handleSpacingsChange(
              `${fieldPath}`,
              'paddingUnit',
              e.target.value.toString()
            );
          }}
          label="Padding Unit"
          options={marginAndPaddingUnitOptions}
        />
        <Input
          label="Margin Top"
          fullWidth
          value={spacings?.marginTop}
          onChange={(e) => {
            handleSpacingsChange(
              fieldPath,
              'marginTop',
              Number(e.target.value)
            );
          }}
        />
        <Input
          label="Margin Right"
          fullWidth
          value={spacings?.marginRight}
          onChange={(e) => {
            handleSpacingsChange(
              fieldPath,
              'marginRight',
              Number(e.target.value)
            );
          }}
        />
        <Input
          label="Margin Bottom"
          fullWidth
          value={spacings?.marginBottom}
          onChange={(e) => {
            handleSpacingsChange(
              fieldPath,
              'marginBottom',
              Number(e.target.value)
            );
          }}
        />
        <Input
          label="Margin Left"
          fullWidth
          value={spacings?.marginLeft}
          onChange={(e) => {
            handleSpacingsChange(
              fieldPath,
              'marginLeft',
              Number(e.target.value)
            );
          }}
        />
        <Select
          fullWidth
          value={spacings?.marginUnit}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            handleSpacingsChange(
              `${fieldPath}`,
              'marginUnit',
              e.target.value.toString()
            );
          }}
          label="Margin Unit"
          options={marginAndPaddingUnitOptions}
        />
      </Box>

      <Box
        paddingTop={2}
        id="spacings-tablet"
        className={styles.accordionWrapper}
      >
        <Accordion
          items={[
            {
              title: (
                <Box className={styles.accordionHeaderContainer}>
                  <span>Tablet</span>
                </Box>
              ),
              children: (
                <Box padding={2}>
                  <Input
                    label="Padding Top"
                    fullWidth
                    value={spacings?.tablet?.paddingTop}
                    onChange={(e) => {
                      handleTabletSpacingsChange(
                        `${fieldPath}`,
                        'paddingTop',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Input
                    label="Padding Right"
                    fullWidth
                    value={spacings?.tablet?.paddingRight}
                    onChange={(e) => {
                      handleTabletSpacingsChange(
                        `${fieldPath}`,
                        'paddingRight',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Input
                    label="Padding Bottom"
                    fullWidth
                    value={spacings?.tablet?.paddingBottom}
                    onChange={(e) => {
                      handleTabletSpacingsChange(
                        `${fieldPath}`,
                        'paddingBottom',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Input
                    label="Padding Left"
                    fullWidth
                    value={spacings?.tablet?.paddingLeft}
                    onChange={(e) => {
                      handleTabletSpacingsChange(
                        `${fieldPath}`,
                        'paddingLeft',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Select
                    fullWidth
                    value={spacings?.tablet?.paddingUnit}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleTabletSpacingsChange(
                        `${fieldPath}`,
                        'paddingUnit',
                        e.target.value.toString()
                      );
                    }}
                    label="Padding Unit"
                    options={marginAndPaddingUnitOptions}
                  />
                  <Input
                    label="Margin Top"
                    fullWidth
                    value={spacings?.tablet?.marginTop}
                    onChange={(e) => {
                      handleTabletSpacingsChange(
                        `${fieldPath}`,
                        'marginTop',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Input
                    label="Margin Right"
                    fullWidth
                    value={spacings?.tablet?.marginRight}
                    onChange={(e) => {
                      handleTabletSpacingsChange(
                        `${fieldPath}`,
                        'marginRight',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Input
                    label="Margin Bottom"
                    fullWidth
                    value={spacings?.tablet?.marginBottom}
                    onChange={(e) => {
                      handleTabletSpacingsChange(
                        `${fieldPath}`,
                        'marginBottom',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Input
                    label="Margin Left"
                    fullWidth
                    value={spacings?.tablet?.marginLeft}
                    onChange={(e) => {
                      handleTabletSpacingsChange(
                        `${fieldPath}`,
                        'marginLeft',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Select
                    fullWidth
                    value={spacings?.tablet?.marginUnit}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleTabletSpacingsChange(
                        `${fieldPath}`,
                        'marginUnit',
                        e.target.value.toString()
                      );
                    }}
                    label="Margin Unit"
                    options={marginAndPaddingUnitOptions}
                  />
                </Box>
              ),
              reducedPadding: true,
            },
          ]}
        />
      </Box>
      <Box
        paddingTop={2}
        id="spacings-mobile"
        className={styles.accordionWrapper}
      >
        <Accordion
          items={[
            {
              title: (
                <Box className={styles.accordionHeaderContainer}>
                  <span>Mobile</span>
                </Box>
              ),
              children: (
                <Box padding={2}>
                  <Input
                    label="Padding Top"
                    fullWidth
                    value={spacings?.mobile?.paddingTop}
                    onChange={(e) => {
                      handleMobileSpacingsChange(
                        `${fieldPath}`,
                        'paddingTop',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Input
                    label="Padding Right"
                    fullWidth
                    value={spacings?.mobile?.paddingRight}
                    onChange={(e) => {
                      handleMobileSpacingsChange(
                        `${fieldPath}`,
                        'paddingRight',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Input
                    label="Padding Bottom"
                    fullWidth
                    value={spacings?.mobile?.paddingBottom}
                    onChange={(e) => {
                      handleMobileSpacingsChange(
                        `${fieldPath}`,
                        'paddingBottom',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Input
                    label="Padding Left"
                    fullWidth
                    value={spacings?.mobile?.paddingLeft}
                    onChange={(e) => {
                      handleMobileSpacingsChange(
                        `${fieldPath}`,
                        'paddingLeft',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Select
                    fullWidth
                    value={spacings?.mobile?.paddingUnit}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleMobileSpacingsChange(
                        `${fieldPath}`,
                        'paddingUnit',
                        e.target.value.toString()
                      );
                    }}
                    label="Padding Unit"
                    options={marginAndPaddingUnitOptions}
                  />
                  <Input
                    label="Margin Top"
                    fullWidth
                    value={spacings?.mobile?.marginTop}
                    onChange={(e) => {
                      handleMobileSpacingsChange(
                        `${fieldPath}`,
                        'marginTop',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Input
                    label="Margin Right"
                    fullWidth
                    value={spacings?.mobile?.marginRight}
                    onChange={(e) => {
                      handleMobileSpacingsChange(
                        `${fieldPath}`,
                        'marginRight',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Input
                    label="Margin Bottom"
                    fullWidth
                    value={spacings?.mobile?.marginBottom}
                    onChange={(e) => {
                      handleMobileSpacingsChange(
                        `${fieldPath}`,
                        'marginBottom',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Input
                    label="Margin Left"
                    fullWidth
                    value={spacings?.mobile?.marginLeft}
                    onChange={(e) => {
                      handleMobileSpacingsChange(
                        `${fieldPath}`,
                        'marginLeft',
                        Number(e.target.value)
                      );
                    }}
                  />
                  <Select
                    fullWidth
                    value={spacings?.mobile?.marginUnit}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleMobileSpacingsChange(
                        `${fieldPath}`,
                        'marginUnit',
                        e.target.value.toString()
                      );
                    }}
                    label="Margin Unit"
                    options={marginAndPaddingUnitOptions}
                  />
                </Box>
              ),
              reducedPadding: true,
            },
          ]}
        />
      </Box>
    </Fragment>
  );
};
